import { Box } from "@mui/material";
import { IoMdClose } from "react-icons/io";
import style from "./index.module.css";

export default function BusinessPartner({ close }) {
  return (
    <Box className={style.container}>
      <Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <IoMdClose
            className={style.close_icon}
            onClick={() => close(false)}
          />
        </Box>
        <Box className={style.content}>
          <h4>Hey Partner!</h4>
          <h5>Do you have a requirement of more than 1,000 Visas per month?</h5>
          <p>For corporate rates, shoot an email to Christina at</p>
          <a style={{ color: "white" }} href="mailto:connect@visaero.com">
            connect@visaero.com
          </a>
          <br />
          <br />
          <p className={style.bot_note}>(She is a real human and not a Bot!)</p>
        </Box>
      </Box>
    </Box>
  );
}
